import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3647159d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3647159d')) {
      api.createRecord('3647159d', component.options)
    } else {
      api.reload('3647159d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3647159d&", function () {
      api.rerender('3647159d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/header-search/index.vue"
export default component.exports